<script lang="ts">
import { defineComponent } from "vue";
import DatePicker from "@/components/DatePicker";
import { getSelectDataSourceFromEnum } from "@/services/dataSourceUtils";
import { ContactAddressType, ContactSalutation } from "@/models/cases/Contact";
import { marketModule } from "@/store/modules/market";
import { MarketGetters } from "@/store/modules/market/getters";
import { MarketActions } from "@/store/modules/market/actions";

export default defineComponent({
    components: { DatePicker },
    computed: {
        ...marketModule.mapGetters({ countries: MarketGetters.Countries })
    },
    methods: {
        ...marketModule.mapActions({
            loadCountries: MarketActions.LoadCountries
        })
    },
    created() {
        this.loadCountries();
    },
    data() {
        return {
            salutations: getSelectDataSourceFromEnum(ContactSalutation),
            addressTypes: getSelectDataSourceFromEnum(ContactAddressType)
        };
    }
});
</script>
